module.exports = __webpack_public_path__ + "img/visa.a7570a90.svg";